import { render, staticRenderFns } from "./PropertyFormInfo.vue?vue&type=template&id=fb7b086a&scoped=true&"
import script from "./PropertyFormInfo.vue?vue&type=script&lang=ts&"
export * from "./PropertyFormInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyFormInfo.vue?vue&type=style&index=0&id=fb7b086a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7b086a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
